import styled from '@xstyled/styled-components';
import React from 'react';
import { createPortal } from 'react-dom';
import { select } from '~/lib/select';
import { settingButtonAnimation } from '~/ui/animation';
import { SettingsButton } from '~/ui/buttons/SettingsButton';
import { useMediaPlayerStore } from '~/ui/video-player/MediaPlayerProvider';
import { MediaPlayerStore } from '~/ui/video-player/MediaPlayerStore';
import { SettingsPages, useSettingsStore } from './Store';

const Button = styled(SettingsButton)`
  position: fixed;
  top: 20px;
  right: 20px;
  font-size: 30px;
  z-index: hud;
  &:hover {
    animation: ${settingButtonAnimation} 1s ease infinite;
  }
  padding: 0px;
  @media ((max-width: 580px) and (max-height: 300px)) {
    right: 10px;
  }
`;

const selector = (s: MediaPlayerStore) => select(s, 'pause');

export const OpenSettingsButton = () => {
  const { toggle, setPage } = useSettingsStore();
  const { pause } = useMediaPlayerStore(selector);

  return createPortal(
    <Button
      onClick={() => {
        setPage(SettingsPages.Root);
        try {
          pause();
        } catch (error) {
          // Silently ignore media player errors
        }
        toggle();
      }}
    />,
    document.getElementById('root')!
  );
};
